import { render, staticRenderFns } from "./DailyProblemPanel.vue?vue&type=template&id=08c35c88&scoped=true&lang=pug&"
import script from "./DailyProblemPanel.vue?vue&type=script&lang=ts&"
export * from "./DailyProblemPanel.vue?vue&type=script&lang=ts&"
import style0 from "./DailyProblemPanel.vue?vue&type=style&index=0&id=08c35c88&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c35c88",
  null
  
)

export default component.exports